import { CallPopUpAgentActions } from "../../../store/slices/voice_call_slice/call_popup_agent";
import { CallService } from "../../../services/call_service";
import { ChatActions } from "../../../store/slices/chat_slice/chat_slice";
import { Cookie } from "../../../base/utils";
import { GetItemFromStorage } from "../../../custom_hooks/useStorage";
import { LocalStorage } from "../../../custom_hooks/localStorageKeys";
import { WtButton } from "../Button/button";
import callChatService from "../../../base/service/chatService";
import { getNecessaryDetailswithmessage, getNecessaryDetailswithsession, showDetials } from "../../../store/api/helperspi/contactListapiService";
import styles from "./callwhisper.module.scss";
import { useDispatcher } from "../../../custom_hooks/use_app_dispatch";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import mike from "../../../styles/images/mikesvg.svg"

function CallWhisper() {
  // let cookieData: any = Cookie.get();
  // let accessTokenValues = JSON.parse(cookieData.userDetials);
  const accessTokenValues = GetItemFromStorage(LocalStorage.USER_DETAILS);
  const LoginCcaasUserDetails = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
  const dispatch = useDispatcher();
  const navigate = useNavigate();
  const { transferChanges, makeReInvite, SupervisorEndCall, basicHold, superVisorUnMuteFunction, superVisorMuteFunction } = CallService(dispatch, navigate);
  const popUpDetails: any = useSelector((state: any) => state.callPopUpDetails);
  let { incomingCallDetail, callDetails, trackAgentDetail, isTrackAgent, monitorType, ShowCallerDetails } = popUpDetails;
  const RoomChat: any = useSelector((state: any) => state.chatReducer);
  const [showDetails, setShowDetails] = useState(true)
  const doBarge = () => {
    let data: any = {
      session_id: trackAgentDetail?.sessionId,
      req_type: "SUPERVISOR",
      switch_type: 3,
      // ext: accessTokenValues.ext,
      email: LoginCcaasUserDetails?.emailId ?? '',
      name: LoginCcaasUserDetails?.UserName ?? '',
      userId: LoginCcaasUserDetails?.UserID ?? '',
      ext: LoginCcaasUserDetails?.ext ?? '',
    };
    callChatService.sendReqFeatures(data);
    dispatch(CallPopUpAgentActions.MonitorType("BARGE"));
  };

  const doWhisper = () => {
    let data: any = {
      session_id: trackAgentDetail?.sessionId,
      req_type: "SUPERVISOR",
      switch_type: 2,
      // ext: accessTokenValues.ext,
      email: LoginCcaasUserDetails?.emailId ?? '',
      name: LoginCcaasUserDetails?.UserName ?? '',
      userId: LoginCcaasUserDetails?.UserID ?? '',
      ext: LoginCcaasUserDetails?.ext ?? '',
    };
    callChatService.sendReqFeatures(data);
    dispatch(CallPopUpAgentActions.MonitorType("WHISPER"));
  };

  const closeMonitorAgent = () => {
    dispatch(ChatActions.sessionRemoveAfterEnd(trackAgentDetail.sessionDetails.sessionId));
    SupervisorEndCall(trackAgentDetail.useragent);
    transferChanges(!isTrackAgent, {});
    dispatch(CallPopUpAgentActions.MonitorType(""));

    let data: any = {
      session_id: trackAgentDetail?.sessionId,
      req_type: "SUPERVISOR",
      switch_type: 5,
      // ext: accessTokenValues.ext,
      email: LoginCcaasUserDetails?.emailId ?? '',
      name: LoginCcaasUserDetails?.UserName ?? '',
      userId: LoginCcaasUserDetails?.UserID ?? '',
      ext: LoginCcaasUserDetails?.ext ?? '',
    };

    callChatService.sendReqFeatures(data);
    dispatch(CallPopUpAgentActions.setShowCallerDetails(false))
    navigate('/allactivity')
    setShowDetails(true)
  };

  const MuteTheExsistingCall = () => {
    //muteTrackAgent
    dispatch(CallPopUpAgentActions.muteTrackAgent(true));
    superVisorMuteFunction();
  };

  const UmMuteTheExsistingCall = () => {
    //muteTrackAgent
    dispatch(CallPopUpAgentActions.muteTrackAgent(false));
    superVisorUnMuteFunction();
  };

  const listenAction = () => {
    let data: any = {
      session_id: trackAgentDetail?.sessionId,
      req_type: "SUPERVISOR",
      switch_type: 1,
      email: LoginCcaasUserDetails?.emailId ?? '',
      name: LoginCcaasUserDetails?.UserName ?? '',
      userId: LoginCcaasUserDetails?.UserID ?? '',
      ext: LoginCcaasUserDetails?.ext ?? '',
    };

    callChatService.sendReqFeatures(data);
    dispatch(CallPopUpAgentActions.MonitorType("LISTEN"));
  };

  const goToWorkspace = async () => {
    let value = { ...trackAgentDetail?.sessionDetails }
    value.isTracker = true
    let details: any = await showDetials({ sessionId: value?.sessionId.trim(), channelType: "Call" })
    if (details?.data?.statusCode === 200) {
      const message_1 = JSON.parse(details?.data?.getEmailListRes[0]?.Message ?? '[]')
      dispatch(ChatActions.agentViewWorkSpaceHistory_WB(Array.isArray(message_1) ? message_1 : []));
      dispatch(ChatActions.chatSessionList(value));
      dispatch(ChatActions.currentChatSession(value));
      navigate("/chatscreenagent");
      dispatch(CallPopUpAgentActions.setShowCallerDetails(true))
    } else {
      dispatch(ChatActions.chatSessionList(value));
      dispatch(ChatActions.currentChatSession(value));
      navigate("/chatscreenagent");
    }
    setShowDetails(false)
  };

  useEffect(() => {

  }, [popUpDetails, accessTokenValues, RoomChat]);

  useEffect(() => {
    if (!ShowCallerDetails && !showDetails) {
      closeMonitorAgent()
    }
  }, [ShowCallerDetails])

  return (
    <>
      <div className={`w3-animate-top ${styles.callwhisperfooter}`}>
        <div className={styles.callwhisperinnercon}>
          <div className={styles.leftsidebar}>
            <span>Lisening with</span>
            <label>{trackAgentDetail?.AgentData?.name}</label>
            {['WHISPER', 'BARGE'].includes(monitorType) && showDetails && <WtButton className={`buttonGreen ${styles.showcallbtn}`} name="Show caller details" onClick={goToWorkspace} />}
            {trackAgentDetail.status === "connected" ? <span>{trackAgentDetail.Duration}</span> : <span>Connecting...</span>}
          </div>
          <div className={styles.rightsidebar}>
            <span>{incomingCallDetail.callduration}</span>
            {monitorType !== "LISTEN" && trackAgentDetail.status === "connected" && (
              <>
                {!trackAgentDetail.muteState ? (
                  <label className={styles.muteicon}>
                    <span  onClick={() => MuteTheExsistingCall()}> <img src={mike} alt=""/></span>
                  </label>
                ) : (
                  <label className={`${styles.muteicon}  ${styles.disabled}`}>
                    <span className="icon__MikeMute20" onClick={() => UmMuteTheExsistingCall()}></span>
                  </label>
                )}
              </>
            )}
            {monitorType !== "LISTEN" && trackAgentDetail.status === "connected" && (
              <WtButton
                className={`buttonGreen ${styles.whisbtn}`}
                name="Listen"
                disabled={trackAgentDetail.status === "connected" ? false : true}
                onClick={() => listenAction()}
              />
            )}

            {monitorType !== "WHISPER" && (
              <WtButton
                className={`buttonGreen ${styles.whisbtn}`}
                name="Whisper"
                disabled={trackAgentDetail.status === "connected" ? false : true}
                onClick={() => doWhisper()}
              />
            )}
            {monitorType !== "BARGE" && (
              <WtButton
                className={`buttonGreen ${styles.whisbtn}`}
                name="Barge"
                disabled={trackAgentDetail.status === "connected" ? false : true}
                onClick={() => doBarge()}
              />
            )}
            <WtButton className={`buttonGreen ${styles.leavecallbtn}`} name="Leave call" onClick={closeMonitorAgent} />
          </div>
        </div>
      </div>
    </>
  );
}
export default CallWhisper;
